export default "__VITE_ASSET__0tlPg4Sx__"